<script>
    import Modal from "../components/Modal_series.svelte";	
    import Modal_alta from "../components/Modal_alta.svelte";	
    import Modal2 from "../components/Modal.svelte";	
    import { Datatable, rows } from 'svelte-simple-datatables'
    import { onMount } from 'svelte';
    import { iddistribuidor, nombre } from '../store/distribuidor.js';
	import { jwt } from "../store/index.js";
    import Top from "../components/top.svelte";	
	import {push, pop, replace} from 'svelte-spa-router';
    import { idcliente_serie, nombre_cliente } from '../store/series.js';
    let iddib = $jwt;
    let data=[]; let show = true;
    let show1 = false;
    let show2 =false;
    let SQL_Host;
    let modal_alta_serie;
    let SQL_Database;
    let SQL_Usuario;
    let SQL_Password;
    let SQL_Puerto;
    let FTP_Host;
    let FTP_Directorio;
    let FTP_Usuario;
    let FTP_Password;
    let FTP_Puerto;
    let idcliente;
    let series=[];
    let idserie;
    let serie;
    let referencia;
    let sistema_operativo;
    let host;
    let sistem = "windows";
    let modal_conceptos;
    let conceptosa=[];
    let modal_alta_servicio;
    let concepto_alta;
    let mensual_alta;
    let fijo_alta;
    let idservicio;
    let show_a=true;
    let show_a1;
    let show_a2;
    let show_a3;
    let correo_sesion;
    let password;
    let actives = "pestaña3";
    let actives1 = "pestaña2"; 
    let actives2 = "pestaña2";
    let actives3 = "pestaña2";
    let modal_alta_cliente;
    let empresa;
    let telefono;
    let celular;
    let correo_empresa;
    let contraseña;
    let correo_representante;
    let representante;

    let activer = "pestaña1";
    let activer1 = "pestaña";
    let activer2 = "pestaña";
    

    async function series_page(i){
        idcliente_serie.set(data[i].idcliente);
        nombre_cliente.set(data[i].Empresa);
        replace("/series");
    }
    async function alta_servicios(){
            modal_alta_servicio.hide();
        try {
            const data = new FormData()
            data.append('concepto', concepto_alta);
            data.append('+¿', mensual_alta);
            data.append('fijo', fijo_alta);
            let res = await fetch('php/create-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		    alert("creado con exito");
            const url1 = 'php/get-conceptos.php';
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function crear_cliente(){
            modal_alta_cliente.hide();
            const url3 = 'php/get-id-activacion.php';
            let res3 = await fetch(url3)
            res3 = await res3.json()
            console.log(res3)
        const data = new FormData()
            data.append('id', iddib);
            data.append('empresa', empresa);
            data.append('telefono', telefono);
            data.append('correo_sesion', correo_sesion);
            data.append('password_cliente', contraseña);
            data.append('contacto', representante);
            data.append('celular', celular);
            data.append('correo', correo_representante);
            data.append('id_activacion', res3);
            let res = await fetch('php/alta-cliente.php', {
                method : "POST",
                body: data
            })
            alert("creado con exito");
            
            const url1 = 'php/get-clientes.php?id=' + iddib;
            let res1 = await fetch(url1)
            res1 = await res1.json()
            data = res.data;
            console.log(data)
    }
    async function actualizar_series(i){
    idcliente = data[i].idcliente
    const url = 'php/get-series.php?id=' + idcliente;
    let res = await fetch(url)
    res = await res.json()
    series = res.data;
    console.log(series)
    }
    async function conceptos(){
        modal_conceptos.show();
    }
    async function alta(){
        modal_alta_serie.show();
    } 
    async function eliminar_servicio(i){
        idservicio = conceptosa[i].idservicio;
        let r2 = window.confirm("¿Desea eliminar el servicio " + conceptosa[i].Concepto + "?");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idservicio);
            let res = await fetch('php/delete-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            alert("Eliminado con exito");
            const url1 = 'php/get-conceptos.php';
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }
    async function eliminar(i){
        idserie = series[i].idlicencia;
        let r2 = window.confirm("¿Desea eliminar la serie " + series[i].Serie + "de" + series[i].Referencia + "?");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idserie);
            let res = await fetch('php/delete-series.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            actualizar_series(i);
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }
    function showa(){
		show_a = true;
		show_a1 = false;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña3";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa1(){
		show_a = false;
		show_a1 = true;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña3";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa2(){
		show_a = false;
		show_a1 = false;
		show_a2 = true;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña3";
        actives3="pestaña2";
	}
    function showa3(){
		show_a = false;
		show_a1 = false;
		show_a2 = false;
        show_a3 = true;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña3";
	}
    function showan(){
		show = true;
		show1 = false;
		show2 = false;
        activer="pestaña1";
        activer1="pestaña";
        activer2="pestaña";
	}
    function showan1(){
		show = false;
		show1 = true;
		show2 = false;
        activer="pestaña";
        activer1="pestaña1";
        activer2="pestaña";
	}
    
    function showan2(){
		show = false;
		show1 = false;
		show2 = true;
        activer="pestaña";
        activer1="pestaña";
        activer2="pestaña1";
	}
    async function alta_serie(){
        modal_alta_serie.hide();
        try {
            const data = new FormData()
            data.append('serie', serie);
            data.append('sistema_operativo', sistem);
            data.append('referencia', referencia);
            data.append('host', host);
            data.append('id', idcliente);
            if(sistem == "Android"){
                data.append('tipo', "1");
            } else if(sistem == "IOS"){
                data.append('tipo', "1");
            } else{
                data.append('tipo', "0");
            }
            let res = await fetch('php/alta-series.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        const url = 'php/get-series.php?id=' + idcliente;
        let resa = await fetch(url)
        resa = await resa.json()
        series = resa.data;
        console.log(series)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }

    onMount(async () => {
        const url = 'php/get-clientes.php?id=' + iddib;
        let res = await fetch(url)
        res = await res.json()
        data = res.data;
        console.log(data)

        const url1 = 'php/get-conceptos.php';
        let resa = await fetch(url1)
        resa = await resa.json()
        conceptosa = resa.data;
        console.log(resa.data)
    })
    const settings = { columnFilter: false }
    let modal;

    async function mostrar(i){
    idcliente = data[i].idcliente
    const url = 'php/get-series.php?id=' + idcliente;
    let res = await fetch(url)
    res = await res.json()
    series = res.data;
    console.log(series)
    SQL_Host = data[i].SQL_Host;
    SQL_Database = data[i].SQL_Database;
    SQL_Usuario = data[i].SQL_Usuario;
    SQL_Password = data[i].SQL_Pass;
    SQL_Puerto = data[i].SQL_Port;
    FTP_Host = data[i].FTP_Host;
    FTP_Directorio = data[i].FTP_Directorio;
    FTP_Usuario = data[i].FTP_Usuario;
    FTP_Password = data[i].FTP_Pass;
    FTP_Puerto = data[i].FTP_Port;
    correo_sesion = data[i].correo_sesion;
    password = data[i].password_cliente;
    modal.show();
    }
</script>
<Top/>
<seciton>
    <div class="informacion_general">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>Clients</h3>
                </div>
                <div class="icon" on:click={() => modal_alta_cliente.show()}>
                    <img src="./img/mas.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</seciton>
<div class="tabla_clientes">
    <table>
        <thead>
            <th class="column">Company</th>
            <th class="column1">Activation ID</th>
            <th class="column2">Register</th>
            <th class="column3">Hosting validity</th>
            <th class="column4">Licenses</th>
            <th class="column5">Series</th>
            <th class="column6">Type</th>
            <th class="column7"></th>
        </thead>
        <tbody>
            {#each data as row, i}
            <tr>
                <td class="column">{row.Empresa}</td>
                <td class="column1">{row.ID_ACTIVACION}</td>
                <td class="column2">{row.Alta}</td>
                <td class="column3">{row.Vigencia_Servicio}</td>
                <td class="column4">{row.Licencias_Pagadas}</td>
                <td class="column5">{row.Series_Activas}</td>
                <td class="column6">{row.tipo_pag}</td>
                <td class="column7" on:click={() => series_page(i)}><img src="./img/ojo.svg" alt=""></td>
            </tr>
            {/each}
        </tbody>
    </table>
</div>

<div class="tabla_clientes_movil">
    <div class="tabla_tecnicos_movil">
        {#each data as row, i}
        <div class="renglon">
            <h4><b>Company: </b>{row.Empresa}</h4>
            <h4><b>Activation ID: </b>{row.ID_ACTIVACION}</h4>
            <h4><b>Register: </b>{row.Alta}</h4>
            <h4><b>Hosting validity: </b>{row.Vigencia_Hosting}</h4>
            <h4><b>Licenses: </b>{row.Licencias_Pagadas}</h4>
            <h4><b>Series: </b>{row.Series_Activas}</h4>
            <h4><b>Type: </b>{row.tipo_pag}</h4>
            <h3 class="column7" on:click={() => series_page(i)}><img src="./img/ojo.svg" alt=""></h3>
        </div>
        {/each}
    </div>
</div>

<Modal2 bind:this={modal}>
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{activer}" on:click={showan}>
                <h4>DB Connection</h4>
            </div>
            <div class="{activer1}" on:click={showan1}>
                <h4>FTP Credentials</h4>
            </div>
        </div>
    </div>
    {#if show}
    <div class="ajuste_modal_info">
            <h4><b>SQL Host:</b>{SQL_Host}</h4>
            <h4><b>SQL Database:</b>{SQL_Database}</h4>
            <h4><b>SQL User:</b>{SQL_Usuario}</h4>
            <h4><b>SQL Password:</b>{SQL_Password}</h4>
            <h4><b>SQL Port:</b>{SQL_Puerto}</h4>
            <h4><b>Session Email:</b> {correo_sesion}</h4>
            <h4><b>Password:</b> {password}</h4>
    </div>
    {/if}
    {#if show1}
    <div class="ajuste_modal_info">
        <h4><b>FTP Host:</b>{FTP_Host}</h4> 
        <h4><b>FTP Directorio:</b>{FTP_Directorio}</h4>
        <h4><b>FTP User:</b>{FTP_Usuario}</h4>
        <h4><b>FTP Password:</b>{FTP_Password}</h4>
        <h4><b>FTP Port:</b>{FTP_Puerto}</h4>
    </div>
    {/if}
</Modal2>
<Modal bind:this={modal_alta_serie}>
    <form on:submit|preventDefault={alta_serie}>
        <h2 class="titulo-modal">New serie</h2>
        <h4 class="texto_modal">Serial number</h4>
        <input type="text" class="input_modal" bind:value={serie} required placeholder="número alfanumerico">
        <h4 class="texto_modal">Operating system or platform</h4>
        <h4>
            <input type="radio" bind:group={sistem} value={"windows"}> Windows
        </h4>
        <h4>
            <input type="radio" bind:group={sistem} value={"Linux"}> Linux
        </h4>
        <h4>
            <input type="radio" bind:group={sistem} value={"Mac OS"}> Mac OS
        </h4>
        <h4>
            <input type="radio" bind:group={sistem} value={"Android"}> Android
        </h4>
        <h4>
            <input type="radio" bind:group={sistem} value={"IOS"}> IOS
        </h4>
        <h4 class="texto_modal">Reference or assigned</h4>
        <input type="text" class="input_modal"  bind:value={referencia} required>
        <h4 class="texto_modal">Connection host:</h4>
        <input type="text" class="input_modal"  bind:value={host} required>
        <button class="modal_button" type="submit">Save</button>
    </form>
</Modal>

<Modal_alta bind:this={modal_alta_servicio}>
    <form on:submit|preventDefault={alta_servicios}>
        <h2 class="titulo-modal">New module</h2>
        <h4 class="texto_modal">Concept</h4>
        <input type="text" class="input_modal" bind:value={concepto_alta} required>
        <h4 class="texto_modal">Monthly price</h4>
        <input type="text" class="input_modal" bind:value={mensual_alta} required>
        <h4 class="texto_modal">fixed price</h4>
        <input type="text" class="input_modal" bind:value={fijo_alta}>
        <button class="modal_button" type="submit">Save</button>
    </form>
</Modal_alta>
<Modal_alta bind:this={modal_alta_cliente}>
    <form on:submit|preventDefault={crear_cliente}>
        <h2 class="titulo-modal">New client</h2>
        <h4 class="texto_modal">Company name:</h4>
        <input type="text" class="input_modal" bind:value={empresa} required>
        <h4 class="texto_modal">Session email:</h4>
        <input type="email" class="input_modal" bind:value={correo_empresa} required>
        <h4 class="texto_modal">Password:</h4>
        <input type="text" class="input_modal" bind:value={contraseña} required>
        <h4 class="texto_modal">Company Phone:</h4>
        <input type="text" class="input_modal" bind:value={telefono}>
        <h4 class="texto_modal">Name of representative:</h4>
        <input type="text" class="input_modal" bind:value={representante} required>
        <h4 class="texto_modal">Email of representative:</h4>
        <input type="email" class="input_modal" bind:value={correo_representante} required>
        <h4 class="texto_modal">Cell phone:</h4>
        <input type="text" class="input_modal" bind:value={celular} required>
      
        <button class="modal_button" type="submit">Save</button>
        <button class="modal_button" on:click={() => modal_alta_cliente.hide()}>Cancel</button>
    </form>
</Modal_alta>